export enum ScheduleSummaryView {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
}
